<template>
    <b-modal :id="'modal-multi-edit-' + id"
               ref="edit-modal"
               size="sm"
               title="編輯"
               centered
               :hide-header="success"
               :content-class="success ? 'success-modal-content' : 'edit-modal-content'"
               :dialog-class="success ? 'success-modal-dialog' : 'edit-modal-dialog'"
               :body-class="success ? 'success-modal-body' : 'edit-modal-body'"
               :header-class="success ? 'success-modal-header' : 'edit-modal-header'"
               :title-class="success ? 'success-modal-title' : 'edit-modal-title'"
               hide-footer
               @shown="assignValue()"
               @hide="initialize()">
        <ValidationObserver ref="form">
          <form @submit.prevent
                v-stream:submit="onSubmit$"
                >
            <transition name="slide-left" mode="out-in">
              <div v-if="success"
                   key="'success'"
                   class="success-modal">
                <CustomLottie
                  :animationData="animationData"
                  style="margin-bottom: 24px;"
                ></CustomLottie>
                <span class="title">你已成功編輯用戶</span>
                 <footer>
                   <b-button size="md"
                            variant="primary"
                            @click="hideModal"
                    >
                    完成
                  </b-button>
                </footer>
              </div>
              <div v-else
                  :key="'form'"
                  class="reset-password__frag"
              >
              <h6>更改分店／店鋪名稱</h6>
                <AGCInput v-model="submerchantName"
                          type="text"
                          name="新分店／店鋪名稱"
                          placeholder="輸入新分店／店鋪名稱"
                          rules="required"
                          required
                ></AGCInput>
                <h6 class="password">更改密碼</h6>
                <span class="password-tips">
                  密碼最少8個字，必須包含數字及大，小寫英文字母（不支援特殊符號）。
                </span>
                <AGCInput v-model="userPassword"
                          type="password"
                          name="密碼"
                          :placeholder="passwordPlaceholder"
                          :rules="{ required: isRequiredPassword }"
                          required
                ></AGCInput>
                <AGCInput v-model="newPassword"
                          type="password"
                          vid="password"
                          ref="password"
                          name="新密碼"
                          placeholder="輸入新密碼"
                          :rules="{ required: isRequiredPassword, password: this.newPassword }"
                          required
                >
                  <template v-slot:invalidFeedback="{ errors }">
                    <span
                      style="font-size: 80%;color:#dc3545;"
                      :style="{ display: errors[0] ? 'block' : 'none' }"
                    >
                      密碼最少8個字，必須包含數字及大，小寫英文字母（不支援特殊符號）。
                    </span>
                  </template>
                </AGCInput>
                <AGCInput v-model="confirmNewPassword"
                          type="password"
                          name="輸入新密碼"
                          placeholder="再次輸入新密碼"
                          :rules="{ required: isRequiredPassword }"
                          required
                ></AGCInput>
                <h6>狀態</h6>
                <AGCSelectGroup
                  v-model="status"
                  :options="defaultStatus"
                  rules="required"
                  :name="status"
                ></AGCSelectGroup>
                <div class="row justify-content-end px-3">
                  <b-button size="md"
                            class="mr-2"
                            variant="light"
                            @click="hideModal"
                            >
                    取消
                  </b-button>
                  <b-button size="md"
                            type="submit"
                            variant="btn btn-primary"
                            :disabled="loading"
                  >
                    提交
                  </b-button>
                </div>
            </div>
          </transition>
        </form>
        </ValidationObserver>
      </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  BModal,
  BButton,
} from 'bootstrap-vue';
import { switchMap, tap } from 'rxjs/operators';
import CustomLottie from '@/components/CustomLottie.vue';
import animationData from '@/assets/lottie/change-password-success.json';
import AGCInput from '@/components/form/AGCInput.vue';
import AGCSelectGroup from '@/components/form/AGCSelectGroup.vue';
import http from '../../helpers/http';
import { getErrorMsg } from '../../helpers/error-msg';
import toastSettings from '../../helpers/toast-settings';
import formMixin from '../../mixins/form';
import agcFormElementMixin from '../../mixins/agc-form-element';

// import http from '../../helpers/http';
// import { getErrorMsg } from '../../helpers/error-msg';
// import toastSettings from '../../helpers/toast-settings';

export default {
  mixins: [agcFormElementMixin, formMixin],
  props: ['id', 'merchantId', 'success', 'item'],
  data: () => ({
    submerchantName: null,
    status: null,
    userPassword: null,
    newPassword: null,
    confirmNewPassword: null,
    defaultStatus: [
      { text: '已啓用', value: 'ACTIVATED' },
      { text: '已停用', value: 'INACTIVATED' },
    ],
    loading: false,
    animationData,
  }),
  computed: {
    ...mapGetters(['role']),
    isRequiredPassword() {
      return !!(this.userPassword || this.newPassword || this.confirmNewPassword);
    },
    passwordPlaceholder() {
      return this.role === 'admin' ? '輸入管理員密碼' : '輸入商戶密碼';
    },
  },
  components: {
    BButton,
    BModal,
    CustomLottie,
    AGCInput,
    AGCSelectGroup,
  },
  methods: {
    hideModal() {
      this.$refs['edit-modal'].hide();
      this.success = false;
    },
    initialize() {
      this.userPassword = null;
      this.newPassword = null;
      this.confirmNewPassword = null;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    assignValue() {
      this.submerchantName = this.item.name;
      this.status = this.item.status;
    },
  },
  domStreams: ['onSubmit$'],
  subscriptions() {
    return {
      submit: this.onSubmit$
        .pipe(
          switchMap(this.validate),
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => http({
            method: 'POST',
            url: `/agc-${this.role}-api/submerchants/update`,
            data: {
              id: this.id,
              name: this.submerchantName,
              username: this.item.username,
              userPassword: this.userPassword,
              newPassword: this.newPassword,
              confirmNewPassword: this.confirmNewPassword,
              status: this.status,
            },
          }, {
            next: () => {
              this.success = true;
              this.item.name = this.submerchantName;
              this.item.status = this.status;
              this.initialize();
            },
            error: ({ data: { msg } }) => {
              this.$bvToast.toast(getErrorMsg(msg), {
                ...toastSettings,
                title: '錯誤',
                toaster: 'b-toaster-top-center',
              });
            },
            complete: () => {
              this.loading = false;
            },
          })),
        ),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/transition/slide";

::v-deep {
.success-modal {
  display: inline-block;
  text-align: center;
  width: 100%;
  .title {
    display: block;
    font-size: 18px;
  }
  &-dialog {
    min-width: 380px;
  }
  &-content {
    border: none;
  }
  &-body {
    padding: 32px;
  }
  .btn {
    margin: 0 auto;
    min-width: 111px;
    padding: 9px 18px;
  }
  footer {
    border: none;
    padding: 28px 0 0 0;
  }
}

.edit-modal {
  &-content {
    border: none;
  }

  &-dialog {
    max-width: 500px;
  }

  &-title {
    font-size: 18px;
    font-weight: 400;
    width: 100%;
  }

  &-header {
    padding: 24px;
    border-bottom: none;
    text-align: center;
  }

  &-header .close {
    font-size: 19px;
    padding-top: 20px;
  }

  &-body {
    padding: 0 24px 24px 24px !important;

    .form-control {
      padding: 12px 14px !important;
      font-size: 15px !important;
      height: 100%;
      border: 1px solid #ced4d9;
    }
    .px-3 {
      padding-top: 8px;
    }
    .btn {
      padding: 9px 18px;
      min-width: 111px;

      &-light {
        margin-right: 12px !important;
        background-color: #f9f9fa;
        border: 1px solid #dde1e5;
        color: #636d77;
      }
    }
    h6.password {
      display: inline-block;
    }

    span.password-tips {
      font-size: 0.7em;
      color: #757575;
    }
  }
}
 .form-control {
  &::-moz-placeholder {
    color: #7e8b93;
    opacity: 1;
    font-weight: 300;
  }
  &:-ms-input-placeholder {
    color: #7e8b93;
    opacity: 1;
    font-weight: 300;
  }
  &::placeholder {
    color: #7e8b93;
    opacity: 1;
    font-weight: 300;
  }
 }
}
</style>
